// Backend money is canonical USD. Display formatting happens here, using the
// org's currency code + rate captured from the lander config (LanderPage) or
// the /organizations/{id} response (TripNewGuide watcher). Symbol/locale rules
// come from the browser's Intl.NumberFormat.
//
// Usage:
//   - On page/org load, callers invoke setCurrency(code, rate).
//   - Any component formats a USD amount by calling formatPrice(amountUsd).
//   - When setCurrency hasn't fired yet (or org is USD), defaults to USD display.

import { ref } from "vue";

const _code = ref("USD");
const _rate = ref(1);

export function setCurrency(code, rate) {
  _code.value = code || "USD";
  _rate.value = Number(rate) > 0 ? Number(rate) : 1;
}

export function formatPrice(amountUsd) {
  if (amountUsd == null || amountUsd === 0) return "TBD";
  const display = parseFloat(amountUsd) * _rate.value;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: _code.value }).format(display);
}
